module.exports = __webpack_public_path__ + "img/clint-mckoy.1d928fbb.jpg";